// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeLearn_wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 60px;
  flex-wrap: wrap;
  padding: 60px 80px;
  background: #faf4fa;

}

/* ---------- Image side ---------- */

.HomeLearn_imageBlock {
  position: relative;
  width: 460px;
  height: 500px;
  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;
}


.HomeLearn_shapeSquare {
  position: absolute;
  top: 18%;
  left: 12%;
  width: 300px;
  height: 320px;
  background: rgba(71, 0, 65, 0.12);
  border: 2px solid rgba(93, 0, 121, 0.5);
  border-radius: 4px;
  opacity: 0;
  animation: HomeLearn_fadeIn 0.8s ease forwards 0.25s;
}

.HomeLearn_imageFrame {
  position: relative;
  width: 320px;
  height: 400px;
  border-radius: 6px;
  overflow: hidden;
  opacity: 0;
  transform: scale(0.92) translateY(20px);
  animation: HomeLearn_imageReveal 0.7s ease forwards 0.4s;
  box-shadow: 0 18px 40px rgba(87, 0, 90, 0.63);
}

.HomeLearn_image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.HomeLearn_badge {
  position: absolute;
  width: 76px;
  height: 76px;
  border-radius:50%;
background-image: linear-gradient(to right, rgb(237, 182, 248), rgb(255, 255, 255));
  color: #2a0033;
  font-size:14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  opacity: 0;
  animation: HomeLearn_badgePop 0.5s ease forwards, HomeLearn_float 3.5s ease-in-out infinite;
}

.HomeLearn_badge--topRight {
  top: 8%;
  right: 6%;
  animation-delay: 0.6s, 1.1s;
}

.HomeLearn_badge--midRight {
  top: 62%;
  right: -2%;
  animation-delay: 0.75s, 1.25s;
}

.HomeLearn_badge--topLeft {
  top: 4%;
  left: 4%;
  animation-delay: 0.9s, 1.4s;
}

.HomeLearn_badge--bottomLeft {
  bottom: 6%;
  left: 8%;
  animation-delay: 1.05s, 1.55s;
}

/* ---------- Text side ---------- */

.HomeLearn_content {
  max-width: 450px;
}

.HomeLearn_heading {
  font-size:40px;
  font-weight: 800;
  font-family:Arial, Helvetica, sans-serif;
  color: #440052;
  line-height: 1.25;
  opacity: 0;
  animation: HomeLearn_slideUp 0.6s ease forwards 0.3s;
}

.HomeLearn_description {
  font-size:19px;
  color: #000000;
  text-align: justify;
    font-family:'Times New Roman', Times, serif;
  line-height: 1.8;
  margin: 0 0 26px;
  opacity: 0;
  animation: HomeLearn_slideUp 0.6s ease forwards 0.5s;
}



/* ---------- Keyframes ---------- */

@keyframes HomeLearn_fadeIn {
  to {
    opacity: 1;
  }
}

@keyframes HomeLearn_imageReveal {
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes HomeLearn_badgePop {
  to {
    opacity: 1;
  }
}

@keyframes HomeLearn_float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes HomeLearn_slideUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ---------- Responsive ---------- */

@media (max-width: 900px) {
  .HomeLearn_wrapper {
    flex-direction: column;
    padding: 40px 24px;
    text-align: center;
  }

  .HomeLearn_imageBlock {
    width: 100%;
    max-width: 380px;
    height: 420px;
  }

  .HomeLearn_content {
    max-width: 100%;
  }

  .HomeLearn_heading {
    font-size: 26px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/HomeLearn/HomeLearn.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,mBAAmB;;AAErB;;AAEA,qCAAqC;;AAErC;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;;EAEd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,iCAAiC;EACjC,uCAAuC;EACvC,kBAAkB;EAClB,UAAU;EACV,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,uCAAuC;EACvC,wDAAwD;EACxD,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB,mFAAmF;EACjF,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,UAAU;EACV,2FAA2F;AAC7F;;AAEA;EACE,OAAO;EACP,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,6BAA6B;AAC/B;;AAEA,oCAAoC;;AAEpC;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,wCAAwC;EACxC,cAAc;EACd,iBAAiB;EACjB,UAAU;EACV,oDAAoD;AACtD;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;IACjB,2CAA2C;EAC7C,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,oDAAoD;AACtD;;;;AAIA,oCAAoC;;AAEpC;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,qCAAqC;;AAErC;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".HomeLearn_wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 60px;\n  flex-wrap: wrap;\n  padding: 60px 80px;\n  background: #faf4fa;\n\n}\n\n/* ---------- Image side ---------- */\n\n.HomeLearn_imageBlock {\n  position: relative;\n  width: 460px;\n  height: 500px;\n  flex-shrink: 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n\n.HomeLearn_shapeSquare {\n  position: absolute;\n  top: 18%;\n  left: 12%;\n  width: 300px;\n  height: 320px;\n  background: rgba(71, 0, 65, 0.12);\n  border: 2px solid rgba(93, 0, 121, 0.5);\n  border-radius: 4px;\n  opacity: 0;\n  animation: HomeLearn_fadeIn 0.8s ease forwards 0.25s;\n}\n\n.HomeLearn_imageFrame {\n  position: relative;\n  width: 320px;\n  height: 400px;\n  border-radius: 6px;\n  overflow: hidden;\n  opacity: 0;\n  transform: scale(0.92) translateY(20px);\n  animation: HomeLearn_imageReveal 0.7s ease forwards 0.4s;\n  box-shadow: 0 18px 40px rgba(87, 0, 90, 0.63);\n}\n\n.HomeLearn_image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.HomeLearn_badge {\n  position: absolute;\n  width: 76px;\n  height: 76px;\n  border-radius:50%;\nbackground-image: linear-gradient(to right, rgb(237, 182, 248), rgb(255, 255, 255));\n  color: #2a0033;\n  font-size:14px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);\n  opacity: 0;\n  animation: HomeLearn_badgePop 0.5s ease forwards, HomeLearn_float 3.5s ease-in-out infinite;\n}\n\n.HomeLearn_badge--topRight {\n  top: 8%;\n  right: 6%;\n  animation-delay: 0.6s, 1.1s;\n}\n\n.HomeLearn_badge--midRight {\n  top: 62%;\n  right: -2%;\n  animation-delay: 0.75s, 1.25s;\n}\n\n.HomeLearn_badge--topLeft {\n  top: 4%;\n  left: 4%;\n  animation-delay: 0.9s, 1.4s;\n}\n\n.HomeLearn_badge--bottomLeft {\n  bottom: 6%;\n  left: 8%;\n  animation-delay: 1.05s, 1.55s;\n}\n\n/* ---------- Text side ---------- */\n\n.HomeLearn_content {\n  max-width: 450px;\n}\n\n.HomeLearn_heading {\n  font-size:40px;\n  font-weight: 800;\n  font-family:Arial, Helvetica, sans-serif;\n  color: #440052;\n  line-height: 1.25;\n  opacity: 0;\n  animation: HomeLearn_slideUp 0.6s ease forwards 0.3s;\n}\n\n.HomeLearn_description {\n  font-size:19px;\n  color: #000000;\n  text-align: justify;\n    font-family:'Times New Roman', Times, serif;\n  line-height: 1.8;\n  margin: 0 0 26px;\n  opacity: 0;\n  animation: HomeLearn_slideUp 0.6s ease forwards 0.5s;\n}\n\n\n\n/* ---------- Keyframes ---------- */\n\n@keyframes HomeLearn_fadeIn {\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes HomeLearn_imageReveal {\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n@keyframes HomeLearn_badgePop {\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes HomeLearn_float {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n@keyframes HomeLearn_slideUp {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ---------- Responsive ---------- */\n\n@media (max-width: 900px) {\n  .HomeLearn_wrapper {\n    flex-direction: column;\n    padding: 40px 24px;\n    text-align: center;\n  }\n\n  .HomeLearn_imageBlock {\n    width: 100%;\n    max-width: 380px;\n    height: 420px;\n  }\n\n  .HomeLearn_content {\n    max-width: 100%;\n  }\n\n  .HomeLearn_heading {\n    font-size: 26px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
